(function () {
  try {
    var ua = (navigator.userAgent || navigator.vendor || window.opera || "").toString();
    var isInApp = /Instagram|FBAN|FBAV|FB_IAB|FBIOS|FBMD|FBSV|Messenger|Line\/|Twitter|musical_ly|Bytedance|TikTok|Snapchat|Pinterest/i.test(ua);
    if (!isInApp) return;
    var SESSION_KEY = "pf_inapp_nudge_dismissed";
    var dismissed = false;
    try { dismissed = sessionStorage.getItem(SESSION_KEY) === "1"; } catch (e) {}
    var nudge   = document.getElementById("pf-inapp-nudge");
    var pill    = document.getElementById("pf-inapp-pill");
    var openBtn = document.getElementById("pf-inapp-open");
    var dismissBtn = document.getElementById("pf-inapp-dismiss");
    if (!nudge || !pill) return;
    var isIOS = /iPhone|iPad|iPod/i.test(ua);
    var isAndroid = /Android/i.test(ua);
    function taggedUrl() {
      var u = window.location.href;
      if (u.indexOf("utm_term=inappredirect") === -1) {
        u += (u.indexOf("?") === -1 ? "?" : "&") + "utm_term=inappredirect";
      }
      return u;
    }
    function openInBrowser() {
      var url = taggedUrl();
      if (isAndroid) {
        var noScheme = url.replace(/^https?:\/\//, "");
        window.location.href = "intent://" + noScheme + "#Intent;scheme=https;package=com.android.chrome;end";
        return;
      }
      if (isIOS) {
        // The x-safari- URL scheme is unreliable on modern iOS and can trigger
        // a "problem loading" error, so copy the link and tell the visitor how
        // to open it in Safari instead.
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(window.location.href).then(function () {
            alert("Link copied. Tap the menu in the corner and choose Open in Safari, or paste the link into Safari for the best checkout experience.");
          }).catch(function () {
            alert("Tap the menu in the top corner and choose Open in Safari for the best checkout experience.");
          });
        } else {
          alert("Tap the menu in the top corner and choose Open in Safari for the best checkout experience.");
        }
        return;
      }
      window.open(url, "_blank");
    }
    function showNudge() {
      if (dismissed) { pill.style.display = "block"; return; }
      nudge.style.display = "flex";
      requestAnimationFrame(function () { nudge.classList.add("pf-show"); });
    }
    function hideNudge() {
      nudge.classList.remove("pf-show");
      setTimeout(function () { nudge.style.display = "none"; }, 280);
      pill.style.display = "block";
    }
    openBtn.addEventListener("click", openInBrowser);
    pill.addEventListener("click", openInBrowser);
    dismissBtn.addEventListener("click", function () {
      try { sessionStorage.setItem(SESSION_KEY, "1"); } catch (e) {}
      dismissed = true;
      hideNudge();
    });
    setTimeout(showNudge, 900);
  } catch (err) {}
})();
